import React from "react";
import { useRadioPlayerContext } from "../../providers/RadioPlayerContext";
import { NextIcon, PauseIcon, PlayIcon, PrevIcon } from "../icons";
import { ClipLoader } from "react-spinners";

const MainContent = () => {
  const {
    currentChannel,
    currentTrack,
    isPlaying,
    isBuffering,
    togglePlayPause,
    prevChannelHandler,
    nextChannelHandler,
  } = useRadioPlayerContext();

  return (
    <div className="z-[10]">
      <div className="aspect-square size-40 xxxs:size-56 mx-auto">
        <img
          key={currentTrack?.title}
          alt={currentTrack?.title}
          src={currentTrack?.cover}
          className="size-full rounded-xl"
        />
      </div>

      <div className="flex flex-col items-center gap-3 my-5 xxxs:my-6">
        <h2 className="font-bold xxxs:font-extrabold text-base xxxs:text-lg">{`کانال ${currentChannel?.channelTitle}`}</h2>
        <h6 className="xxxs:font-bold text-sm">{`جریان موسیقی از رادیو آنلاین موزیکیوم`}</h6>
      </div>

      <div className="flex items-center justify-center gap-5 xxxs:gap-8">
        <NextIcon onClick={prevChannelHandler} className="size-5 xxxs:size-7" />
        <button onClick={togglePlayPause}>
          {isBuffering ? (
            <ClipLoader size={36} color="#fff" />
          ) : isPlaying ? (
            <PauseIcon className="size-12 xxxs:size-14" />
          ) : (
            <PlayIcon className="size-12 xxxs:size-14" />
          )}
        </button>
        <PrevIcon onClick={nextChannelHandler} className="size-5 xxxs:size-7" />
      </div>
    </div>
  );
};

export default MainContent;
